import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { LanguageContext } from "../context/LanguageContext";

const resolveDeviceId = (data) =>
  data?.deviceId ||
  data?.sourceDeviceId ||
  data?.raw?.source_device?.id ||
  data?.raw?.automation?.device?.id ||
  null;

const resolveDeviceLabel = (data) =>
  data?.deviceName ||
  data?.raw?.source_device?.name ||
  data?.raw?.automation?.device?.name ||
  data?.device ||
  data?.sourceDid ||
  "-";

const resolveDeviceDid = (data) =>
  data?.sourceDid ||
  data?.device ||
  data?.raw?.source_did ||
  data?.raw?.sourceDevice ||
  "-";

const NotificationDetailsModal = ({ state, setState }) => {
  const { lang } = useContext(LanguageContext);
  const isRtl = ["ar", "ur"].includes(lang);
  const navigate = useNavigate();

  if (!state?.open) return null;

  const data = state?.data || {};
  const deviceId = resolveDeviceId(data);
  const deviceLabel = resolveDeviceLabel(data);
  const deviceDid = resolveDeviceDid(data);

  const closeModal = () => {
    setState({
      open: false,
      data: null,
    });
  };

  const openDeviceDetails = () => {
    if (!deviceId) return;
    closeModal();
    navigate(`/devices/details/${deviceId}`);
  };

  return (
    <div id="modal" dir={isRtl ? "rtl" : "ltr"}>
      <div id="popup" className="dashboard-modal">
        <div className="dashboard-header">
          <div className="dashboard-header-text">
            <h2>Notification Details</h2>
            <p>{data?.message || "-"}</p>
          </div>
        </div>

        <div className="modal-divider" />

        <div className="modal-content dashboard-content">
          <div className="form-section">
            <div className="form-item">
              <label className="form-lbl">Time</label>
              <input
                className="add-column"
                value={data?._time ? moment(data._time).format("YYYY-MM-DD HH:mm:ss") : ""}
                readOnly
              />
            </div>

            <div className="form-item">
              <label className="form-lbl">Device</label>
              <div className="notif-device-detail-row">
                <input className="add-column" value={deviceLabel} readOnly />
                <button
                  type="button"
                  className="notif-device-link-btn"
                  onClick={openDeviceDetails}
                  disabled={!deviceId}
                  title={deviceId ? "Open device details" : "Device details are not available"}
                  aria-label="Open device details"
                >
                  <OpenInNewOutlinedIcon fontSize="small" />
                </button>
              </div>
            </div>

            <div className="form-item">
              <label className="form-lbl">Device DID</label>
              <input className="add-column" value={deviceDid} readOnly />
            </div>

            <div className="form-item">
              <label className="form-lbl">Organization</label>
              <input className="add-column" value={data?.organization || "-"} readOnly />
            </div>

            <div className="form-item">
              <label className="form-lbl">Template</label>
              <input className="add-column" value={data?.template || "-"} readOnly />
            </div>

            <div className="form-item">
              <label className="form-lbl">Source</label>
              <input className="add-column" value={data?.source || "-"} readOnly />
            </div>

            <div className="form-item">
              <label className="form-lbl">Notification Type</label>
              <input className="add-column" value={data?.notificationType || "-"} readOnly />
            </div>

            <div className="form-item">
              <label className="form-lbl">Message</label>
              <textarea className="add-column" value={data?.message || ""} readOnly rows={5} />
            </div>
          </div>
        </div>

        <div className="modal-footer dashboard-footer">
          <div />
          <div className="modal-footer-right-buttons">
            <button className="btn btn-cancel" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationDetailsModal;
